import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import get from "lodash/get";
import { AccessType, Link } from "@quintype/components";
import { DefaultAuthor } from "../header-components/header-template/default-author";
import TimeAgo from "react-timeago";
import format from "date-fns/format";

import "./user-details.m.css";

function UserDetailsBase(props) {
  const email = get(props, ["member", "email"]);
  const phone = get(props, ["member", "metadata", "phone-number"], "");
  const accessTypeKey = get(props, ["config", "theme-attributes", "accesstypeKey"]);
  const disableMetering = get(props, ["config", "theme-attributes", "disableMetering"]) === "true";
  const isStaging = get(props, ["config", "theme-attributes", "accesstypeEnvironment"]) === "staging";
  const enableAccesstype = get(props, ["config", "theme-attributes", "enableAccesstype"]) === "true";

  return (
    <AccessType
      enableAccesstype={enableAccesstype}
      isStaging={isStaging}
      accessTypeKey={accessTypeKey} // "9rm1ijqQmGfJ2kwQ9zt2gWhK"
      email={email}
      phone={phone}
      disableMetering={disableMetering}
    >
      {({ getSubscriptionForUser }) => (
        <UserDetailsComponent getSubscriptionForUser={getSubscriptionForUser} {...props} />
      )}
    </AccessType>
  );
}

class UserDetailsComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      subscriptions: []
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.subscriptions.length !== this.props.subscriptions.length) {
      this.getUserSubscriptions();
    }
  }

  getUserSubscriptions = async () => {
    const subscriptions = await this.props.getSubscriptionForUser();
    this.setState({ subscriptions });
  };

  renderImage() {
    const image = get(this.props, ["member", "avatar-url"]);
    if (image) {
      return <img src={image} />;
    }
    return (
      <span>
        <DefaultAuthor />
      </span>
    );
  }

  formatter(value, unit, suffix, date, defaultFormatter) {
    return format(new Date(date), "DD MMM, YYYY");
  }

  renderUserDetailsContent = () => {
    const email = get(this.props, ["member", "email"], "");
    const phone = get(this.props, ["member", "phone"]);
    const name = get(this.props, ["member", "name"], "");
    const endPlan = get(this.state, ["subscriptions", "subscriptions", 0, "end_timestamp"]);
    return (
      <Fragment>
        <div styleName="container-wrapper">
          <div styleName="author-image">{this.renderImage()}</div>
          <div styleName="author-details">
            <h2 styleName="author-name">{name}</h2>
            {endPlan ? (
              <div styleName="subs-details">
                <span styleName="annual-subscription">Subscription</span>
                <span styleName="expire-time">
                  expires on
                  <span styleName="expire-time">
                    <TimeAgo date={endPlan} formatter={this.formatter} />
                  </span>
                </span>
              </div>
            ) : (
              <span styleName="subs-details"> No subscriptions yet</span>
            )}
            <div styleName="email-detail">
              <span>EMAIL</span>
              <p>{email}</p>
            </div>
            {phone && (
              <div styleName="mob-detail">
                <span>PHONE</span>
                <p>{phone}</p>
              </div>
            )}
            <div styleName="other-detail">
              <div styleName="plan-btn">
                <Link href={"/subscription"}>Upgrade Plan</Link>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  };

  handleIfLoggedIn = () => {
    const { member } = this.props;
    if (!member)
      return (
        <div styleName="navigation-home-wrapper">
          <p>You have been successfully logged out</p>
          <div styleName={"navigate-home"}>
            <Link href={"/"}>Go to Home Page</Link>
          </div>
        </div>
      );
    return this.renderUserDetailsContent();
  };

  render = () => {
    return <div>{this.handleIfLoggedIn()}</div>;
  };
}

UserDetailsComponent.propTypes = {
  getSubscriptionForUser: PropTypes.func,
  member: PropTypes.object,
  subscriptions: PropTypes.array
};

const mapStateToProps = state => ({
  config: get(state, ["qt", "config"]),
  member: get(state, ["member"], null),
  subscriptions: get(state, ["subscriptions"], [])
});

const UserDetails = connect(mapStateToProps)(UserDetailsBase);

export { UserDetails };
